export default __webpack_public_path__ + "static/recognition-banner-a84cbce7c216a42b7929b7ff12988a3f.webp";